module.exports = __webpack_public_path__ + "img/chess_japanchess14.9c34c3cd.png";